import './LineItemsModal.scss';
import clsx from 'clsx';
import React from 'react';

import FileViewer from '@/src/components/project/Inbox2/components/EntryPanel/FileEntryViewer/components/FileViewer/FileViewer';
import { cn } from '@/src/util/ui';

import { useFileEntryViewer } from '../../../../../../store/fileEntryViewer.store';

const LineItemsModal = ({
  children,
  containerClassName = '',
  fileViewerClasses = '',
  modalContentClasses = '',
}) => {
  const { fileEntry } = useFileEntryViewer();

  return (
    <div
      className={cn('modal fade container--lineItems bg-overlay show in', containerClassName)}
      data-backdrop="static"
      data-keyboard="false"
      id="lineItemsModal"
    >
      <div
        className={clsx(
          'modal-dialog',
          'tw-w-full',
          'tw-absolute tw-bottom-0',
          'tw-mx-0 tw-mt-0 tw-mb-auto'
        )}
      >
        {/* File Preview */}
        <FileViewer
          file={{
            id: fileEntry.file.id,
            name: fileEntry.file.name,
            rawName: fileEntry.file.rawName,
          }}
          className={cn(
            'tw-relative tw-w-[50%] tw-overflow-y-auto tw-m-auto tw-scroll-styles',
            fileViewerClasses
          )}
        />

        <div
          className={cn(
            'modal-content',
            // (!) is not removed here as it is to override the styles from vendor.css
            '!tw-rounded-[5px] !tw-shadow-[4px_0px_4px_rgba(0,0,0,0.25)]',
            modalContentClasses
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default LineItemsModal;
